export default function selectedMatchReducer(selectedMatchId, sports, leagues, matches, action) {
    switch (action.type) {
    }
    return selectedMatchId;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/selectedMatchReducer.js